function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useOverlayContext, ConfirmationModal } from 'seagull';
import { ErrorText } from "../../constants";
import { useStoreActions } from "../../contexts";
import { ErrorResponse, ServerError } from "../../infra/ErrorResponse";
import { AgreementTerminationModal } from "./AgreementTerminationModal";
import { jsx as _jsx } from "react/jsx-runtime";
const sharedModalConfig = {
  closeOnClickOutside: true,
  closeOnEscapeKey: true,
  shouldBlurBackground: true
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any

export function useTerminateAgreement() {
  const {
    api,
    logBI
  } = useStoreActions();
  const overlayContext = useOverlayContext();
  async function doActionWithToasts(action, successMessage, errorMessage) {
    try {
      await action();
      overlayContext.showSuccessToast(successMessage, 'termination-success-toast');
    } catch (err) {
      overlayContext.showErrorToast(errorMessage(err), 'termination-failure-toast');
    }
  }
  async function simpleApproveTermination(config) {
    const {
      modalProps,
      successMessage,
      errorMessage,
      action,
      biCallerContext,
      biName
    } = config;
    const confirmed = await overlayContext.showModal(_objectSpread(_objectSpread({}, sharedModalConfig), {}, {
      biCallerContext: biCallerContext !== null && biCallerContext !== void 0 ? biCallerContext : undefined,
      biName: biName,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/_jsx(ConfirmationModal, _objectSpread(_objectSpread({}, modalProps), {}, {
          skin: "danger",
          onPrimaryButtonClick: () => dismissModal(true),
          onSecondaryButtonClick: () => dismissModal(false),
          bi: modalProps.bi
        }));
      }
    }));
    if (confirmed) {
      await doActionWithToasts(action, successMessage, errorMessage);
    }
  }
  return {
    terminateAgreementById: async config => {
      const {
        id,
        postAction,
        biCallerContext
      } = config;
      const result = await overlayContext.showModal(_objectSpread(_objectSpread({}, sharedModalConfig), {}, {
        biCallerContext,
        content: p => /*#__PURE__*/_jsx(AgreementTerminationModal, _objectSpread({
          relationshipId: id
        }, p))
      }));
      const {
        confirmed,
        notification
      } = result || {};
      if (confirmed) {
        await doActionWithToasts(async () => {
          logBI(10573, {});
          await api.relationship.terminateAgreement(id, notification || null);
          await postAction();
        }, 'Agreement was terminated successfully', e => new ErrorResponse(e).hasServerError(ServerError.RelationshipAlreadyTerminated) ? 'Agreement already terminated' : 'Failed to terminate agreement');
      }
    },
    terminateDraftById: (id, postAction, biCallerContext) => simpleApproveTermination({
      action: async () => {
        await api.draft.deleteById(id);
        await postAction();
      },
      successMessage: 'Draft was discarded successfully',
      errorMessage: () => 'Failed to discard draft',
      biName: 'terminate_draft_modal',
      biCallerContext,
      modalProps: {
        bi: {
          modal: {
            name: 'terminate_draft_modal'
          },
          primaryButton: {
            name: 'terminate_draft_modal_primary_button'
          },
          secondaryButton: {
            name: 'terminate_draft_modal_secondary_button'
          }
        },
        title: 'Discard this draft?',
        content: "If you discard this draft it will be removed from the system and you won't be able to access it",
        primaryButtonLabel: 'Discard draft',
        secondaryButtonLabel: 'Keep draft'
      }
    }),
    cancelProposalById: (id, postAction) => simpleApproveTermination({
      action: async () => {
        const loaderName = 'cancelProposal';
        overlayContext.startLoader(loaderName);
        try {
          await api.relationship.cancelProposal(id);
          await postAction();
        } finally {
          overlayContext.stopLoader(loaderName);
        }
      },
      successMessage: 'Proposal was canceled successfully',
      errorMessage: err => new ErrorResponse(err).hasServerError(ServerError.InvalidRelationshipStatus) ? ErrorText.ProposalAlreadyAcceptedOrCanceled : 'Failed to cancel proposal',
      modalProps: {
        title: 'Cancel this proposal?',
        content: 'If you cancel this proposal it will be removed from the system and neither you or your client will have access to it.',
        primaryButtonLabel: 'Cancel proposal',
        secondaryButtonLabel: 'Keep proposal'
      }
    })
  };
}